module.exports = __webpack_public_path__ + "img/bg-world.08911d6f.svg";